// src/pages/Users/Inscription/components/FinalSummaryPanel.jsx

import React from "react";
import {
  FaCheckCircle,
  FaEuroSign,
  FaLayerGroup,
  FaPaperPlane,
  FaSpinner,
} from "react-icons/fa";

import StepCard from "./StepCard";
import { formatEuro } from "../utils/inscriptionUtils";

export default function FinalSummaryPanel({
  selectedGroups,
  totalAmount,
  canSubmit,
  submitting,
}) {
  return (
    <StepCard
      step="6"
      title="Finalisation"
      icon={<FaCheckCircle />}
      description="Vérifiez le récapitulatif puis validez l’inscription."
      right={
        <div className="rounded-3xl border border-emerald-200 bg-emerald-50 px-5 py-4 text-emerald-800 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300">
          <p className="text-xs font-bold uppercase tracking-[0.18em]">
            Total estimé
          </p>
          <p className="mt-1 text-2xl font-bold">{formatEuro(totalAmount)}</p>
        </div>
      }
    >
      <div className="grid gap-5 lg:grid-cols-[1fr_320px]">
        <div className="rounded-3xl border border-slate-200 bg-slate-50 p-5 dark:border-slate-800 dark:bg-slate-950/70">
          <div className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
              <FaLayerGroup />
            </span>

            <div>
              <p className="text-sm font-bold text-slate-900 dark:text-white">
                Groupe(s) sélectionné(s)
              </p>
              <p className="text-xs text-slate-500 dark:text-slate-400">
                {selectedGroups.length} groupe(s) dans le dossier
              </p>
            </div>
          </div>

          {selectedGroups.length ? (
            <div className="mt-4 space-y-2">
              {selectedGroups.map((group) => {
                const total =
                  Number(group.tarif_licence || 0) +
                  Number(group.tarif_cotisation || 0);

                return (
                  <div
                    key={group.id}
                    className="flex flex-col gap-2 rounded-2xl bg-white p-3 ring-1 ring-slate-200 dark:bg-slate-900 dark:ring-slate-800 sm:flex-row sm:items-center sm:justify-between"
                  >
                    <div>
                      <p className="font-bold text-slate-900 dark:text-white">
                        {group.nom}
                      </p>
                      <p className="text-xs text-slate-500 dark:text-slate-400">
                        {group.discipline_groupe || "Discipline non renseignée"}
                      </p>
                    </div>

                    <p className="inline-flex items-center gap-2 rounded-full bg-emerald-50 px-3 py-1 text-sm font-bold text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300">
                      <FaEuroSign />
                      {formatEuro(total)}
                    </p>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="mt-4 rounded-2xl border border-dashed border-slate-300 bg-white p-4 text-sm text-slate-600 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300">
              Aucun groupe sélectionné.
            </p>
          )}
        </div>

        <div className="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-900">
          <p className="text-sm font-bold text-slate-900 dark:text-white">
            Prêt à valider ?
          </p>

          <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
            Après validation, l’adhérent sera créé, rattaché à votre compte et
            un dossier d’inscription sera généré.
          </p>

          <button
            type="submit"
            disabled={!canSubmit}
            className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-[#013E8E] px-5 py-4 text-sm font-bold text-white shadow-sm transition hover:bg-[#012f6d] disabled:cursor-not-allowed disabled:opacity-50 dark:bg-indigo-500 dark:hover:bg-indigo-400"
          >
            {submitting ? (
              <>
                <FaSpinner className="animate-spin" />
                Enregistrement...
              </>
            ) : (
              <>
                <FaPaperPlane />
                Valider l’inscription
              </>
            )}
          </button>

          {!canSubmit ? (
            <p className="mt-3 text-xs leading-5 text-slate-500 dark:text-slate-400">
              Complétez les champs obligatoires, sélectionnez au moins un groupe
              et cochez les validations nécessaires.
            </p>
          ) : (
            <p className="mt-3 text-xs leading-5 text-emerald-600 dark:text-emerald-300">
              Le dossier semble complet. Vous pouvez finaliser l’inscription.
            </p>
          )}
        </div>
      </div>
    </StepCard>
  );
}